var render = function render(){var _vm=this,_c=_vm._self._c;return _c('topo',{scopedSlots:_vm._u([{key:"ajuda",fn:function(){return [_c('ajuda')]},proxy:true},{key:"configuracoes",fn:function(){return [_c('configuracoes')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }